import { connect } from 'react-redux';
import PortalModal from './PortalModal';
import { goPopup } from 'Store/actions/portalModalActions';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector } from 'Store/selectors';

const mapDispatchToProps = (dispatch) => ({
  handleClose: () => {
    dispatch(goPopup(''));
  },
});

const mapStateToProps = (state) => ({
  title: nullSafe(() => portalModalSelector(state).data.title, ''),
  subtitle: nullSafe(() => portalModalSelector(state).data.subtitle, ''),
  hasOutcome: nullSafe(() => portalModalSelector(state).data.hasOutcome, false),
  outcome: nullSafe(() => portalModalSelector(state).data.outcome, ''),
  closeIcon: nullSafe(() => portalModalSelector(state).data.closeIcon, false),
  buttons: nullSafe(() => portalModalSelector(state).data.buttons, []),
  path: nullSafe(() => portalModalSelector(state).data.path, ''),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  actions: dispatchProps,
}))(PortalModal);
